export function dateFormatter(date: Date): string {
    const localDateString = date.toLocaleDateString("en-CA");
    const formattedDate = `${localDateString}T00:00:00.000+00:00`;

    return formattedDate;
}
